module.exports = __webpack_public_path__ + "img/coti.af93cc15.svg";